































































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

@Component({})
export default class Passwords extends Vue {

  private newPassword: string = '';

  private isSaving: boolean = false;
  private isLoading: boolean = true;

  private passwords: any[] = [];
  private visiblePasswordIndex = -1;

  protected async created() {
    this.isLoading = true;
    try {
      const response = await axios.get('passwords');
      this.passwords = response.data;
    } catch (e) {
      this.passwords = [];
      this.$notify({type: 'error', text: e.message});
    }
    this.isLoading = false;
  }

  protected async addPassword() {
    if (this.passwords.includes(this.newPassword)) {
      this.$notify({type: 'warning', text: `Password already exists.`});
      this.newPassword = '';
      return;
    }
    await this.save(
      this.passwords.concat([this.newPassword])
    );
    this.newPassword = '';
    this.$notify({type: 'success', text: 'The password has been added.'});
  }

  protected async deletePassword(password) {
    await this.save(
      this.passwords.filter((it) => it !== password)
    );
    this.$notify({type: 'success', text: 'The password has been deleted.'});
  }

  protected showPassword(index) {
    this.visiblePasswordIndex = index;
  }

  protected hidePassword() {
    this.visiblePasswordIndex = -1;
  }

  private async save(passwords) {
    this.isSaving = true;
    try {
      await axios.post('passwords', passwords);
      this.passwords = passwords;
    } catch (e) {
      this.$notify({type: 'error', text: e.message});
    }
    this.isSaving = false;
  }
}
